import { isAbortError, requestJson, type JsonRequest } from "../http/httpClient";
import { UiErrorException } from "../../errors/uiError";

/** Full-corpus impact, merge and carry-forward may take several minutes (M3-9-C6). */
export const CORPUS_REVIEW_TIMEOUT_MS = 10 * 60 * 1000;

export async function corpusReviewRequest<T>(request: JsonRequest<T>): Promise<T> {
  const deadline = new AbortController();
  const timer = window.setTimeout(() => { deadline.abort(); }, CORPUS_REVIEW_TIMEOUT_MS);
  const signal = request.signal === undefined ? deadline.signal : AbortSignal.any([request.signal, deadline.signal]);
  try {
    return await requestJson({ ...request, signal });
  } catch (error) {
    if (isAbortError(error) && deadline.signal.aborted && request.signal?.aborted !== true) {
      throw new UiErrorException({ kind: "serverUnreachable" });
    }
    throw error;
  } finally {
    window.clearTimeout(timer);
  }
}
